import ApiConfig from "../config/Api.config";
import Data from "../data/Api.data";
import Request from "../interfaces/Request.interface";
import Response from "../interfaces/Response.interface";
import UsuarioModel from "../models/Usuario.model";
// import UsuarioModel from "../models/Usuario.model";

const urlREDECO: string = `${Data.URLS.urlApiREDECO}`
// const url : string =`${ApiConfig.urlApi}/usuario`

const listarMedioRecepcion = async () => {
    const request: Request = {
        url: `${urlREDECO}/catalogos/medio-recepcion`,
        method: "GET",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const listarNivelAtencion = async () => {
    const request: Request = {
        url: `${urlREDECO}/catalogos/niveles-atencion`,
        method: "GET",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const listarEstados = async () => {
    const request: Request = {
        url: `${urlREDECO}/sepomex/estados`,
        method: "GET",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const listarCodigosPostales = async (estado_id: number) => {
    const request: Request = {
        url: `${urlREDECO}/sepomex/codigos-postales/?estado_id=${estado_id}`,
        method: "GET",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const listarMunicipios = async (estado_id: number, cp: number) => {
    const request: Request = {
        url: `${urlREDECO}/sepomex/municipios/?estado_id=${estado_id}&cp=${cp}`,
        method: "GET",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const listarColonias = async (cp: number) => {
    const request: Request = {
        url: `${urlREDECO}/sepomex/colonias/?cp=${cp}`,
        method: "GET",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const guardarQueja = async (queja: any) => {    
    const token: string = UsuarioModel.getToken();
    const request: Request = {
        url: `${urlREDECO}/redeco/quejas`,
        method: "POST",
        data: [queja],
        headers: { Authorization: token }
    }
    const response: Response = await ApiConfig.executeRequestEspacial(request);
    return response;
};

const eliminarQueja = async (folio: string) => {
    const token: string = UsuarioModel.getToken();
    const request: Request = {
        url: `${urlREDECO}/redeco/quejas?quejaFolio=${folio}`,
        method: "DELETE",
        headers: { Authorization: token }
    }
    const response: Response = await ApiConfig.executeRequestEspacial(request);
    return response;
};


const REDECOServices = {
    listarMedioRecepcion,
    listarNivelAtencion,
    listarEstados,
    listarColonias,
    listarMunicipios,
    listarCodigosPostales,
    // *******
    guardarQueja,
    eliminarQueja
};

export default REDECOServices;